(ns iris.styles.search
  (:require
;;    [herb.core :refer [<class <id]]
  ;;  [garden.units :refer [px]]
   [shadow.css :refer [css]]
   ))



;; must use position sticky !important to override position relative from bootstrap css...styled components were able to override that somehow
(def $navbar
  (css
   :sticky
   :top-0
   [:md {:top "-25px"}]
   {:position "sticky !important"
    :z-index 10000}))

(def $search-wrap
  (css
   :relative
   [:md :text-right :pr-2.5]
   {:background "#f5f5f5"
    :z-index 1031}))

(def $search-bar
  (css :p-1))

(def $search-btn
  (css [:md {:margin "0 5px"}]
       [:hover {:background-color "#ccc"}]
       {:color "#333"
        :background-color "#ddd"
        :border-color "#ddd"
        :margin "5px 5px 0 0"}))

(def $search-help-icon
  (css
   {:color "#333"
    :font-size "1.5rem"}))

(def $input-label
  (css {:color "#333"
        :font-weight "normal"
        :margin "0 5px 0 5px"}
       ["@media (min-width: 360px)" {:margin "0 10px 0 10px"}]))

(def $input-wrap-dev
  (css
   :inline-block
   ["@media (max-width: 430px)" :w-full]
   {:line-height "4.5rem"}))


(def $input-wrap-span
  (css
   {:border "1px #9999999e solid"
    :padding "6px"
    :margin "5px"
    :border-radius "5px"
    :vertical-align "middle"}))

(def $index-input-wrap-span
  (let [$index-ext (css ["@media (max-width: 430px)" {:float "right"
                                                      :margin "auto"
                                                      :line-height "20px"}] )]
    [$input-wrap-span $index-ext]))


(def $order-input-wrap-span
  (let [$order-ext (css ["@media (max-width: 430px)" {:float "left"
                                                      :margin "auto"
                                                      :line-height "20px"}])]
    [$input-wrap-span $order-ext]))




(defn $search-help-div [state]
  (let [$display (if (true? state) (css :block) (css :hidden))
        $base (css
               :absolute
               :right-0
               :w-full
               :bg-black
               :text-left
               [:md {:width "400px"
                     :top "45px"}]
               {:top "80px"
                :padding "5px 10px"})]
    [$base $display]))


(def $search-help-h4
  (css
   ;;  :text-base ;; 1rem becomes only 10px, probably inheritance issue, set to 16px for now
    :font-bold
   {:font-size "16px"}))

(def $search-help-td
  (css
   :w-1of2)
  ;; {:width "50%"}
  )




;; works but no need for this - hidden state never gets activated, js just removes the component entirely
;; (defn $search-bar [state]
;;   (let [$base (css {:padding "5px"})
;;         $display (if (true? state)
;;                    (css :block)
;;                    (css :hidden))]
;;     [$base $display]))

;; TODO: navbar should not be in search namespace... perhaps the other way around...
;; also admin top bar is now a webcomponent so any css referencing it here should be removed.
;; (defn navbar []
;;   ^{:media {{:screen :only :min-width "768px"} {:top "-25px"}}}
;;   {:position "sticky"
;;    :top 0
;;    :z-index 10000})

;; not in use it seems
;; (defn admin-top-bar []
;;   {:z-index 1030
;;    :height "25px"
;;    :width "100%"
;;    :padding "3px 10px"
;;    :position "relative" ;; need this to make this bar go over logs panel
;;    })

;; not in use it seems
;; (defn service-info []
;;   {:float "right"
;;    :display "inline-block"
;;    :margin-right "15px"})

;; (defn search-wrap []
;;   ^{:media {{:screen :only :min-width "768px"} {:text-align "right"
;;                                                 :padding-right "10px"}}}
;;   {:background "#f5f5f5"
;;    :z-index 1031
;;    :position "relative"})



;; not in use it seems
;; (defn search-icon []
;;   {
;;   ;;  :position "fixed"
;;    :position "absolute"
;;    :right "15px"
;;   ;;  :top "5px"
;;   ;;  :top "-70px"
;;    :color "black"
;;    :cursor "pointer"
;;    :line-height "22px"})


;; (defn search-bar [state]
;;   (let [display (if (true? state) "block" "none")]
;;     {:display display
;;      :padding "5px"}))


;; (defn search-btn []
;;   ^{:pseudo {:hover {:background-color "#ccc"}}
;;     :media {{:screen :only :min-width "768px"} {:margin "0 5px"}}}
;;   {:margin "5px 5px 0 0"
;;    :color "#333"
;;    :background-color "#ddd"
;;    :border-color "#ddd"})


;; (defn search-help-icon []
;;   {:color "#333"
;;    :font-size "1.5rem"})


;; (defn input-label []
;;   ^{:media {{:screen :only :min-width "360px"} {:margin "0 10px 0 10px"}}}
;;   {:color "#333"
;;    :font-weight "normal"
;;    :margin "0 5px 0 5px"})


;; (defn input-wrap-dev []
;;   ^{:media {{:screen :only :max-width "430px"} {:width "100%"}}}
;;   {:display "inline-block"
;;    :line-height "4.5rem"})


;; (defn input-wrap-span []
;;   {:border "1px #9999999e solid"
;;    :padding "6px"
;;    :margin "5px"
;;    :border-radius "5px"
;;    :vertical-align "middle"})


;; (defn index-input-wrap-span []
;;   ^{:extend input-wrap-span}
;;   ^{:media {{:screen :only :max-width "430px"} {:float "right"
;;                                                  :margin "auto"
;;                                                  :line-height "20px"}}}
;;   {})


;; (defn order-input-wrap-span []
;;   ^{:extend input-wrap-span}
;;   ^{:media {{:screen :only :max-width "430px"} {:float "left"
;;                                                  :margin "auto"
;;                                                  :line-height "20px"}}}
;;   {})


;; (defn search-help-div [state]
;;   (let [display (if (true? state) "block" "none")]
;;       ^{:media {{:screen :only :min-width "768px"} {:width "400px"
;;                                                 :top "45px"}}}
;;     {:display display
;;      :position "absolute"
;;      :top "80px"
;;      :right 0
;;      :width "100%"
;;      :background "black"
;;      :text-align "left"
;;      :padding "5px 10px"}))


;; (defn search-help-h4 []
;;   {:font-size "16px"
;;    :font-weight "bold"})


;; (defn search-help-td []
;;   {:width "50%"})